/*
  Author: Shilpa, Prasuk
  Info  : Defines the routes within the application
*/

import Vue from "vue";
import Router from "vue-router";
import LoginComponenet from "./views/loginnew.vue";
import SecureComponent from "./views/newlanding.vue";
import AllCommodities from "@/components/allCommodities.vue";
import MyCommodities from "@/components/mycommodities.vue";
import InspectionTemplate from "@/components/inspectionTemplate.vue";
import InspectionSummary from "@/components/inspectionSummary.vue";
import ImageAnalysis from "@/components/ImageAnalysis.vue";
import AdminCenter from '@/components/Users/admincenter.vue';
import GroupCenter from '@/components/Users/grpcenter.vue';
import SelectCommodity from '@/components/selectCommodity.vue';
import formTemp from "@/components/newformTemp.vue";
import SummaryContent from "@/components/SummaryContent.vue";
import PotatoReportSummary from "@/components/potato/summary/potatoSummary.vue";
import PotatoReports from '@/components/potato/newReports.vue';
import Page404 from './views/pagenotfound.vue';
import LandingPage from './views/newlanding.vue';
import newcommodities from '@/components/newCommodities/Commodities.vue';
import PotatoSample from '@/components/potato/newSamples/newSamples.vue';
import ConfigureUsers from '@/components/Users/ConfigureUsers/ConfigureUsers.vue'
// import ConfigureUsers from '@/components/Users/ConfigureUsers/ConfigureUsers.vue'
import EditUser from '@/components/Users/ConfigureUsers/EditUser.vue';
import EditGroup from '@/components/Users/Configgrp/editgrp.vue'
import configgrp from '@/components/Users/Configgrp/configgrp.vue'

// Onion Commodity
import OnionSample from './components/onion/newSamples/OnionSamples.vue'
import OnionSummary from './components/onion/summary/OnionSummary.vue'
import OnionReport from './components/onion/OnionReports.vue'
// Onion Commodity

//#region  Autonomous Inspection
import VisualRecognition from './components/VisualRecognition/VisualRecognition.vue'
import VisualRecognitionListView from './components/VisualRecognition/VisualRecognitionListView/VisualRecognitionListView.vue'
import VisualRecognitionDetailView from './components/VisualRecognition/VisualRecognitionDetailView/VisualRecognitionDetailView.vue'
//#endregion

import store from './store';

Vue.use(Router);
// 
var samplesPages = {
  "onion": OnionSample,
  'potato': PotatoSample
}
var summaryPages = {
  "onion": OnionSummary,
  'potato': PotatoReportSummary
}
var reportsPages = {
  "onion": OnionReport,
  "potato": PotatoReports
}
var router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    // page scroll to top for all route navigations
    return {
      x: 0,
      y: 0
    }
  },
  routes: [
    // Defines the route
    /*{
      path: '/app',
      redirect: {
          name: "login"
      }
  }*/
    // ,
    {
      path: "/app/login",
      name: "login",
      component: LoginComponenet
    },
    //The next 2 routes are being used for testing
    {
      path: "/app/pagenotfound",
      name: "page404",
      component: Page404
    },
    // {
    //   path: "/app/test2",
    //   name: "newlanding",
    //   component: LandingPage,
    //   children: [{
    //       path: 'check/:commodity/:activeTab',
    //       name: 'trial1',
    //       component: OnionSample,
    //     },
    //     {
    //       path: 'check2',
    //       name: 'trial2',
    //       component: EditGroup,
    //     },
    //   ]
    // },
    {
      path: "/app/secure",
      name: "secure",
      component: LandingPage,
      children: [{
          path: 'myCommodities',
          name: 'myCommodities',
          component: MyCommodities
        },
        {
          path: 'commodities',
          name: 'commodities',
          component: AllCommodities
        },
        {
          path: 'inspectionTemplate',
          name: 'inspectionTemplate',
          component: InspectionTemplate,
          children: [{
              path: 'generalInfo/:commodity',
              name: 'potatoGeneralInfo',
              component: formTemp
            },
            {
              path: 'selectCommodity',
              name: 'selectCommodity',
              component: newcommodities,
            },

            {
              path: 'samples/:commodity/:docId/:activeTab',
              name: 'samples',
              component: PotatoSample
            },
            {
              path: 'report/:commodity/:docId',
              name: 'report',
              component: PotatoReports
            },
            {
              path: 'summary/:commodity/:docId',
              name: 'potatoSummary',
              component: PotatoReportSummary,
            },
            {
              path: '/',
              redirect: {
                name: "selectCommodity"
              }
            },
            {
              path: '*',
              redirect: {
                name: "page404"
              }
            }
          ]
        },
        {
          path: 'admincenter',
          name: 'admincenter',
          component: AdminCenter,
          children: [{
              path: 'users',
              name: 'ConfigureUsers',
              component: ConfigureUsers
            },
            {
              path: 'create',
              name: 'EditUser',
              component: EditUser
            }, {
              path: 'edit/:userId',
              name: 'EditUser',
              component: EditUser
            },
            {
              path: '',
              redirect: {
                name: 'ConfigureUsers'
              }
            },
            {
              path: '*',
              redirect: {
                name: "page404" //changed_here
              }
            }
          ]
        },
        {
          path: 'group',
          name: 'groupcenter',
          component: GroupCenter,
          children: [{
              path: 'all',
              name: 'ConfigureGroup',
              component: configgrp
            },
            {
              path: 'create',
              name: 'createGroup',
              component: EditGroup
            }, {
              path: 'edit/:grpId',
              name: 'EditGroup',
              component: EditGroup
            },
            {
              path: '',
              redirect: {
                name: 'ConfigureGroup'
              }
            },
            {
              path: '*',
              redirect: {
                name: "page404" //changed_here
              }
            }
          ]
        },
        {
          path: 'bi',
          name: 'bi',
          component: ImageAnalysis
        },
        {
          path: 'visualrecognition',
          name: 'visualrecognition',
          component: VisualRecognition,
          children:
          [
            
            {
              path: '',
              redirect: {
                name: 'VisualRecognitionListView',
              }
            },    
            {
              path: 'list',
              name: 'VisualRecognitionListView',
              component: VisualRecognitionListView
            },    
            {
              path: 'create',
              name: 'VisualRecognitionDetailView',
              component: VisualRecognitionDetailView
            },
            
            {
              path: 'view/:commodity/:id',
              name: 'VisualRecognitionDetailView',
              component: VisualRecognitionDetailView
            },
            
            {
              path: '*',
              redirect: {
                name: "page404" //changed_here
              }
            }
            
          ]
        },
        {
          path: 'inspectionSummary',
          name: 'inspectionSummary',
          component: InspectionSummary,
          children: [

            {
              path: 'report/:commodity/:docId',
              name: 'report',
              component: PotatoReports
            },
            {
              path: 'edit/generalInfo/:commodity/:docId',
              name: 'potatoGeneralInfo',
              component: formTemp
            },
            {
              path: 'edit/samples/potato/:docId/:activeTab',
              name: 'samples',
              component: PotatoSample
            },
            {
              path: 'edit/summary/potato/:docId',
              name: 'potatoSummary',
              component: PotatoReportSummary,
            },
            {
              path: 'summary',
              name: 'SummaryContent',
              component: SummaryContent
            },

            {
              path: '',
              redirect: {
                name: 'SummaryContent',
              }
            },
            {
              path: '*',
              redirect: {
                name: "page404" //changed_here
              }
            }
          ]
        },
        {
          path: '*',
          redirect: {
            name: "page404"
          }
        },
      ]
    },

    {
      path: '*',
      redirect: {
        name: "login"
      }
    },
  ]
});
router.beforeEach((to, from, next) => {
  // Executes before each routes.
  store.state.prevRoute = from.path
  if (to.path != '/app/login') {
    if (!store.state.token) return next('/app/login')
  }
  var l = to.matched.length
  if (to.path.includes('/samples/')) {
    to.matched[l - 1].components.default = samplesPages[to.params.commodity]
  } else if (to.path.includes('/summary/')) {
    to.matched[l - 1].components.default = summaryPages[to.params.commodity]
  }
  else if (to.path.includes('/report/')) {
    to.matched[l - 1].components.default = reportsPages [to.params.commodity]
  }
  next()
})

export default router;